
import { AuthService } from "@/services/auth-service";
import { InitInfo } from "@/utils/init-info";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import { UserInfo } from "../../models/dossier/user-info";
import { checkVAT, countries } from "jsvat-next";

export default FormLike.extend({
	data(){
		return {
			vatHasBeenBlured: false
		};
	},
	computed: {
		wfUser(): UserInfo | null {
			return AuthService.wfUser;
		},
		currentDossier(): string {
			return AuthService.wfDossier.name;
		},
		vatIsValid():boolean{
			if (this.content.vatNo == "") {
				return true;
			}
			let vatNo = this.content.vatNo.replaceAll(".", "").replaceAll(" ", "");
			if (/^[0-9]{8,12}$/.test(vatNo)){
				return true;
			}
			let result = checkVAT(vatNo, countries);
			return result.isValid;
		}
	},
	props: {
		content: Object as () => InitInfo,
		controlsDisabled: Boolean
	},
	methods: {
		submit() {
			this.$emit("next");
		},
		logout() {
			this.$emit("logout");
		}
	},
	mounted() {
		if (this.currentDossier) {
			this.content.companyName = this.currentDossier;
		}

		if (this.wfUser) {
			this.content.email = this.wfUser.Email;
			this.content.tel = this.wfUser.Phone;
		}
	},
	i18nEx: {
		componentPrefix: "components.init-modal"
	}
});
